import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueMovitel = (stateDate, endDate) => {
  return `${API_PATHS.movitelRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};
// export const apiRevenueMagicWheel = (stateDate, endDate) => {
//   return `${API_PATHS.movitelMagicWheel}?startDate=${stateDate}&endDate=${endDate}`;
// };
// export const apiErrorCodeMovitel = (stateDate, endDate) => {
//   return `${API_PATHS.movitelErrorCode}?startDate=${stateDate}&endDate=${endDate}`;
// };
